import React from 'react';
import styled, { keyframes } from 'styled-components';

import BeLiveLoaderUrl from '../../assets/images/loaders/belive-loader.png';
import { FullScreenOverlay } from '../FullScreenOverlay';

const rotationAnimation = keyframes`
  from {transform: rotate(0deg);}
  to {transform: rotate(359deg);}
`;

export const StyledLoader = styled.div`
  background-image: ${`url(${BeLiveLoaderUrl})`};
  width: 100px;
  height: 100px;
  background-size: contain;
  will-change: transform;
  // TODO bring loaders to single format, right now kaltura and belive loaders are pngs
  // all other loaders are apngs and don't need rotation
  animation: ${rotationAnimation} 2.3s infinite linear;
`;

export const FullScreenLoader = () => {
  return (
    <FullScreenOverlay>
      <StyledLoader />
    </FullScreenOverlay>
  );
};
